(function () {
  'use strict';

  /* @ngdoc object
   * @name orders.list
   * @description
   *
   */
  angular
    .module('parcels.edit.orders.list', [
      'ui.router'
    ]);
}());
